import _ from 'lodash'
import i18n from '@/lang'
import { CookedCategory } from '@/types/dmaker/category.type'

type EmptyObject = Record<string, never>;
export default function useIdToFindCategory({ category, categoryId } : {
  category: Array<CookedCategory>;
  categoryId: number
}) : CookedCategory | EmptyObject {
  if (!_.isArray(category)) {
    throw new Error(String(i18n.t('playTurbo.creative.useIdToFindResourceList.warning4')))
  }

  let cate : CookedCategory | EmptyObject = {}
  const rec = (category: Array<CookedCategory>) => {
    category.forEach(item => {
      if (item.id === categoryId) cate = item
      if (Array.isArray(item.sub_category)) rec(item.sub_category)
    })
  }
  rec(category)
  return cate
}

